import { render, staticRenderFns } from "./InfluencerMatchResult.vue?vue&type=template&id=661d5b6b&"
import script from "./InfluencerMatchResult.vue?vue&type=script&lang=js&"
export * from "./InfluencerMatchResult.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerMatchResult.vue?vue&type=style&index=0&id=661d5b6b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports